/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=517bedb4&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=517bedb4&lang=scss"
import "./App.vue?vue&type=style&index=1&id=517bedb4&lang=scss&scoped=true"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.22_vue@3.5.22_typescript@5.9.3__webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-517bedb4"]])

export default __exports__